import React from 'react';

import { XAxis, YAxis, Tooltip } from 'recharts';
import { BarChart as RechartsBarChart, Bar, ResponsiveContainer } from 'recharts';

// ROY G BIV
const colors = [
  '#dc3545',
  '#fd7e14',
  '#ffc107',
  '#198754',
  '#0d6efd',
  '#6610f2',
  '#6f42c1',
  '#d63384',
  '#20c997',
  '#0dcaf0',
  '#6c757d',
  '#212529'
];

const BarChart = ({ data, xAxisLabel, yAxisLabel, dataFields = ['value'] }) => (
  <div style={{ width: '100%', height: 300 }}>
    <ResponsiveContainer>
      <RechartsBarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <XAxis dataKey={'name'} label={{ value: xAxisLabel, position: 'insideBottom' }} />
        <YAxis label={{ value: yAxisLabel, angle: -90, position: 'insideLeft' }} />
        <Tooltip />
        {dataFields.map((f, index) => (
          <Bar key={index} dataKey={f} stackId="a" fill={colors[index]} />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  </div>
);

export default BarChart;
